import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["thinking", "controls"]

  start() {
    if (this.hasControlsTarget) this.controlsTarget.classList.add("hidden")
    if (this.hasThinkingTarget) this.thinkingTarget.classList.remove("hidden")
  }
}
